import React from 'react';
import { Link, withRouter, Route, Switch } from 'react-router-dom';
import { Query } from 'react-apollo';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { AdminSidebar } from 'constant';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import PRODUCTS from 'constant/product-types';
import gql from 'graphql-tag';
import { toUserTimezone } from 'utils';
import Header from 'components/header';
import Alert from '@material-ui/lab/Alert';

const GET_STUDENT = gql`
  query user($user_id: Int!) {
    users: v_students(where: { user_id: { _eq: $user_id } }) {
      name
      user_last_name  
      product_type
      is_trial
      subscriptions {
        end_date
      }
    }
  }
`;

const PRODUCTS_LOOKUP = PRODUCTS.reduce((memo, i) => {
  memo[i.value] = i.label;
  return memo;
}, {});

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 32,
  },
  alert:{
    marginLeft:"-3em",
    marginTop:"1em"

  }
}));

const MENU_ITEMS = [
  { label: 'Account Details', to: '/profile/account' },
  { label: 'Notification Settings', to: '/profile/settings' },
];

const Navigation = ({ history, toggleMenu }) => {
  const classes = useStyles();

  return (
    <Header
      toggleMenu={toggleMenu}
      routes={AdminSidebar}
      showNotifications
      dropdownItems={MENU_ITEMS}
      renderTitle={(pageTitle) => (
        <Switch>
          <Route
            path="/students/:id"
            render={(props) => (
              <Query
                query={GET_STUDENT}
                variables={{ user_id: props.match.params.id }}
                fetchPolicy="cache-first"
              >
                {({ data }) => {
                  const student = data?.users[0];
                  const subEndDays =
                    student && student.subscriptions.length
                      ? toUserTimezone(student.subscriptions[0].end_date).diff(
                          new Date(),
                          'd',
                        )
                      : null;
                  return (
                    <Box paddingTop={2}>
                      <Box display="flex" alignItems="start">
                        <IconButton
                          edge="start"
                          color={'primary'}
                          onClick={() => history.goBack()}
                          style={{ marginRight: 8 }}
                          size="small"
                        >
                          <ArrowBackIcon />
                        </IconButton>
                        <Box display="flex" flexDirection="column">
                          <div>
                            <span>{student?.name} {student?.user_last_name}</span>
                            {student?.product_type && (
                              <Chip
                                style={{ marginLeft: 5 }}
                                variant={'outlined'}
                                label={PRODUCTS_LOOKUP[student?.product_type]}
                                color="default"
                                size="small"
                              />
                            )}
                          </div>
                          {subEndDays !== null &&
                            subEndDays <= 30 &&
                            subEndDays > 1 && (
                              <Alert className={classes.alert} severity="warning">
                  <Typography color="secondary" variant="smallBold">
                  Your program ends in {subEndDays}  days please add-on and renew your program.
                  </Typography>
                </Alert>
                            )}
                          {!student?.is_trial && subEndDays <= 0 && (
                            <Typography color="secondary" variant="caption">
                              Your program has ended.
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  );
                }}
              </Query>
            )}
          />
          <Route
            path="/curriculum/:moduleId/exercises/:id"
            render={(props) => (
              <p className={classes.title}>
                <IconButton
                  color={'primary'}
                  onClick={() => history.goBack()}
                  style={{ marginRight: 8 }}
                >
                  <ArrowBackIcon />
                </IconButton>
                <span>Curriculum Builder</span>
              </p>
            )}
          />
          <Route
            path="/meeting/:conferenceId/view"
            render={(props) => (
              <p className={classes.title}>
                <IconButton
                  color={'primary'}
                  onClick={() => history.goBack()}
                  style={{ marginRight: 8 }}
                >
                  <ArrowBackIcon />
                </IconButton>
                <span>Meeting Notes</span>
              </p>
            )}
          />
          <Route path="/inbox/messages" render={() => <>Chat</>} />
          <Route path="/inbox/sms" render={() => <>Text Messages</>} />
          <Route path="/inbox/email" render={() => <>Email Messages</>} />
          <Typography className={classes.title} variant="h4">{pageTitle}</Typography>
        </Switch>
      )}
    />
  );
};

export default withRouter(Navigation);
